import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableControleListPage = withAsyncLoading(async () =>
    import('./ControleListPage').then((res) => res.ControleListPage)
);

export { LoadableControleListPage };
